import { combineReducers } from '@reduxjs/toolkit';
import statsReducer from './slices/statsSlice';
import dashboardReducer from './slices/dashboardSlice';
import identitiesReducer from './slices/identitiesSlice';
import authActivityReducer from './slices/authActivitySlice';
import authEventsReducer from './slices/authEventsSlice';
import policiesReducer from './slices/policiesSlice';
import integrationsReducer from './slices/integrationsSlice';
import authReducer from './slices/authSlice';
import userReducer from './slices/getUsers';
import tenantReducer from './slices/tenantSlice';
import visualReducer from './slices/visualSlice'
import adapidMfaReducer from './slices/adapIdMfaSlice'
import {mfaReducer} from "./slices/visualSlice";

const appReducer = combineReducers({
  stats: statsReducer,
  dashboard: dashboardReducer,
  identities: identitiesReducer,
  authActivity: authActivityReducer,
  authEvents: authEventsReducer,
  policies: policiesReducer,
  integrations: integrationsReducer,
  auth: authReducer,
  users: userReducer,
  tenant: tenantReducer,
  visuals: visualReducer,
  adapidMfa:adapidMfaReducer,
  mfaDept: mfaReducer
});

// Root reducer that resets state on logout
export const rootReducer = (state, action) => {
  // When logout action is dispatched, reset all state except auth (which is already cleared)
  if (action.type === 'auth/logout') {
    // Return completely fresh state
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default rootReducer;